import { GetBusinessAccountInvoiceInstructionsArgs } from 'types/api/arguments/get-business-account-invoice-instructions-args'
import { BusinessAccountInvoiceInstructionsResp } from 'types/api/response/business-account-invoice-instructions-resp'

import { api } from './api'

export const getBusinessAccountInvoiceInstructions = ({
  transactionId,
}: GetBusinessAccountInvoiceInstructionsArgs) =>
  api.get<BusinessAccountInvoiceInstructionsResp>(
    `transactions/${transactionId}/business_account_invoice_instructions`,
  )
